import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import d from "./DropdownDivider.js";
import u from "./DropdownGroupHeader.js";
import m from "./DropdownOption.js";
import { isDividerNode as f } from "./utils.js";
import { warn as l } from "../../_utils/naive/warn.js";
import { defineComponent as s, h as e, Fragment as a } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const x = s({
  name: "NDropdownGroup",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNode: {
      type: Object,
      required: !0
    },
    parentKey: {
      type: [String, Number],
      default: null
    }
  },
  render() {
    const {
      tmNode: o,
      parentKey: i,
      clsPrefix: t
    } = this, {
      children: n
    } = o;
    return e(a, null, e(u, {
      clsPrefix: t,
      tmNode: o,
      key: o.key
    }), n == null ? void 0 : n.map((r) => {
      const {
        rawNode: p
      } = r;
      return p.show === !1 ? null : f(p) ? e(d, {
        clsPrefix: t,
        key: r.key
      }) : r.isGroup ? (l("dropdown", "`group` node is not allowed to be put in `group` node."), null) : e(m, {
        clsPrefix: t,
        tmNode: r,
        parentKey: i,
        key: r.key
      });
    }));
  }
});
export {
  x as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/dropdown/src/DropdownGroup.js
// module id = 1682
// module chunks = 67